export const urlWithProtocolRegex =
  /^(https?:\/\/)([a-zA-Z\d]([a-zA-Z\d-]*[a-zA-Z\d])?\.)+[a-zA-Z]{2,}(:\d+)?(\/[-a-zA-Z\d%_.~+]*)*(\?[;&a-zA-Z\d%_.~+=-]*)?(#[^-][a-zA-Z\d_]*)?$/i;
